import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        return location.pathname.indexOf(link) === 0
    }

    public activeClass(link: string) {
        if (this.isActive(link)) {
            return "group flex gap-x-2 items-center rounded-md bg-gray-100 px-2 py-1.5 text-[13px] font-medium text-zinc-950";
        }
        return "group flex gap-x-2 items-center rounded-md px-2 py-1.5 text-[13px] font-medium text-gray-600 hover:bg-gray-50 hover:text-zinc-950";
    }

    public normalizedRole() {
        const role = (this.service.auth.session?.role || "").trim();
        const aliases: any = {
            "Admin": "admin",
            "ADMIN": "admin",
            "SystemAdmin": "admin",
            "SYSTEM_ADMIN": "admin",
            "system_admin": "admin",
            "administrator": "admin",
            "recruit_admin": "RECRUIT_ADMIN",
            "RecruitAdmin": "RECRUIT_ADMIN",
            "RECRUITMENT_ADMIN": "RECRUIT_ADMIN",
            "RecruitmentAdmin": "RECRUIT_ADMIN"
        };
        return aliases[role] || role;
    }

    public isAdmin() {
        const role = this.normalizedRole();
        const id = (this.service.auth.session?.id || "").trim().toLowerCase();
        const email = (this.service.auth.session?.email || "").trim().toLowerCase();
        return role === "admin" || id === "admin" || email === "admin";
    }

    public hasSessionPermission(permission: string) {
        const session: any = this.service.auth.session || {};
        const permissions = session.permissions || session.recruit_permissions || session.permission || [];
        if (Array.isArray(permissions)) return permissions.includes(permission);
        if (typeof permissions === "string") {
            return permissions.split(",").map((item: string) => item.trim()).includes(permission);
        }
        if (permissions && typeof permissions === "object") return !!permissions[permission];
        return false;
    }

    public canShowMyInterviews() {
        return !!(this.service.auth.session?.id || "").trim();
    }

    public canShowMyTasks() {
        return !!(this.service.auth.session?.id || "").trim();
    }
}

export default ComponentNavSidebarComponent;